export type ServerErrorResponse = {
  name: string
  message: string
  meta?: {
    [field: string]: string[]
  }
}
